<div class="track-carousel">
  <div class="track-carousel__cards" #scrollContainer>
    @for (ct of courseTracks; track ct; let i = $index) {
      <ut-academy-course-card
        [courseTrack]="ct"
        [status]="statuses[i]"
        (courseClick)="onCourseClick($event)"
      ></ut-academy-course-card>
    }
  </div>

  @if (canScrollLeft || canScrollRight) {
    <div
      class="track-carousel__arrows"
      >
      <button
        class="track-carousel__arrow-btn"
        (click)="scrollPrev()"
        [disabled]="!canScrollLeft"
        aria-label="Scroll left"
        >
        <svg class="track-carousel__arrow-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M15.8334 9.99984H4.16675M4.16675 9.99984L10.0001 15.8332M4.16675 9.99984L10.0001 4.1665" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button
        class="track-carousel__arrow-btn"
        (click)="scrollNext()"
        [disabled]="!canScrollRight"
        aria-label="Scroll right"
        >
        <svg class="track-carousel__arrow-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M4.16675 9.99984H15.8334M15.8334 9.99984L10.0001 4.1665M15.8334 9.99984L10.0001 15.8332" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  }
</div>
